import { EmployeeInterface } from "../../interfaces/EmployeeInterface";
import { getUserFullName } from "../getUserFullName";

export const getEmployeeOptions = (
    employees?: EmployeeInterface[],
): { value: string; label: string }[] => {
    if (!employees) {
        return [];
    }

    return (
        employees.map((employee: EmployeeInterface) => ({
            label: getUserFullName(employee.user) ?? "",
            value: employee.id.toString(),
        })) || []
    );
};
